import ReactDOM from 'react-dom';
import React from 'react';
import FnArtworkCanvas from '../../../../../../../client/components/elements/FnArtworkCanvas';

const containerId = 'complexArtworkCanvas';

export const canvas = (function () {
  let $canvas = null;

  let render = ({
    blankUri,
    templateUri,
    area,
    arts,
    texts,
    artworkPositionChangedHandler,
    textPositionChangedHandler
  }) => {
    const canvasElement = document.getElementById(containerId);

    if (!canvasElement) {
      return;
    }

    ReactDOM.render(
      React.createElement(FnArtworkCanvas, {
        blankUri,
        templateUri,
        area,
        arts,
        texts,
        onArtworkChange: (art, index) => {
          if (typeof artworkPositionChangedHandler === 'function') {
            artworkPositionChangedHandler(art, index);
          }
        },
        onTextChange: (art, index) => {
          if (typeof textPositionChangedHandler === 'function') {
            textPositionChangedHandler(art, index);
          }
        },
        onCanvasInit: (canvas) => {
          $canvas = canvas;
        }
      }),
      canvasElement,
    );
  };

  let destroy = () => {
    const canvasElement = document.getElementById(containerId);

    if (!canvasElement) {
      return;
    }

    ReactDOM.unmountComponentAtNode(canvasElement);
  };

  let getArtworkBBox = (index) => {
    if (!$canvas) {
      return null;
    }

    if (!$canvas?.$ArtTransformers?.[index]) {
      return { x: 0, y: 0, w: 0, h: 0 };
    }

    const position = $canvas.$ArtTransformers[index].getPosition();

    return {
      x: Math.round(position.art.x / $canvas.$canvasData.aspectRatio - $canvas.$canvasData.area.x),
      y: Math.round(position.art.y / $canvas.$canvasData.aspectRatio - $canvas.$canvasData.area.y),
      w: Math.round(position.bbox.w / $canvas.$canvasData.aspectRatio),
      h: Math.round(position.bbox.h / $canvas.$canvasData.aspectRatio),
    };
  };

  return {
    render,
    destroy,
    getArtworkBBox,
  };
})();
